import React, { Component } from "react";
import { Select, MenuItem, Grid } from "@material-ui/core";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import { MuiPickersUtilsProvider, DatePicker } from "material-ui-pickers";
import EventIcon from "@material-ui/icons/Event";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";

const dateFormat = "DD-MM-YYYY";
const monthFormat = "MMM YYYY";

class AdminDateFilter extends Component {
    state = {
        filterType: "monthly",
        startDate: moment().startOf("month"),
        endDate: moment().endOf("month")
    };

    handleFilterTypeChange = (e) => {
        const value = e.target.value;
        let startDate, endDate;

        switch (value) {
            case "today":
                startDate = moment().startOf("day");
                endDate = moment().endOf("day");
                break;
            case "week":
                startDate = moment().startOf("week");
                endDate = moment().endOf("week");
                break;
            case "monthly":
                startDate = moment().startOf("month");
                endDate = moment().endOf("month");
                break;
            case "quarter":
                startDate = moment().startOf("quarter");
                endDate = moment().endOf("quarter");
                break;
            case "year":
                startDate = moment().startOf("year");
                endDate = moment().endOf("year");
                break;
            case "allTime":
                startDate = moment("2020-01-01");
                endDate = moment().endOf("day");
                break;
            case "custom":
                startDate = this.state.startDate;
                endDate = this.state.endDate;
                break;
            default:
                startDate = moment().startOf("month");
                endDate = moment().endOf("month");
        }

        this.setState({ filterType: value, startDate, endDate }, () => {
            if (value !== "custom") {
                this.props.onDateChange(startDate, endDate);
            }
        });
    };

    handleMonthChange = (value) => {
        const startDate = moment(value).startOf("month");
        const endDate = moment(value).endOf("month");
        this.setState({ startDate, endDate }, () => {
            this.props.onDateChange(startDate, endDate);
        });
    };

    handleStartDateChange = (value) => {
        this.setState({ startDate: value }, () => {
            this.props.onDateChange(this.state.startDate, this.state.endDate);
        });
    };

    handleEndDateChange = (value) => {
        this.setState({ endDate: value }, () => {
            this.props.onDateChange(this.state.startDate, this.state.endDate);
        });
    };

    render() {
        const { filterType, startDate, endDate } = this.state;

        return (
            <Grid container spacing={8} justify="flex-end" alignItems="center">
                <Grid item>
                    <Select
                        value={filterType}
                        onChange={this.handleFilterTypeChange}
                        className="dark-select slim-input"
                        style={{ minWidth: 120 }}
                    >
                        <MenuItem value="today">Today</MenuItem>
                        <MenuItem value="week">This Week</MenuItem>
                        <MenuItem value="monthly">Month</MenuItem>
                        <MenuItem value="quarter">This Quarter</MenuItem>
                        <MenuItem value="year">This Year</MenuItem>
                        <MenuItem value="allTime">All Time</MenuItem>
                        <MenuItem value="custom">Custom</MenuItem>
                    </Select>
                </Grid>

                {filterType === "monthly" && (
                    <Grid item>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <DatePicker
                                views={["year", "month"]}
                                value={startDate}
                                onChange={this.handleMonthChange}
                                format={monthFormat}
                                className="dark-datepicker slim-month-input"
                                autoOk
                                keyboardIcon={<EventIcon />}
                                leftArrowIcon={<KeyboardArrowLeftIcon />}
                                rightArrowIcon={<KeyboardArrowRightIcon />}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                )}

                {filterType === "custom" && (
                    <>
                        <Grid item>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <DatePicker
                                    value={startDate}
                                    onChange={this.handleStartDateChange}
                                    format={dateFormat}
                                    className="dark-datepicker slim-input"
                                    label="From"
                                    keyboardIcon={<EventIcon />}
                                    leftArrowIcon={<KeyboardArrowLeftIcon />}
                                    rightArrowIcon={<KeyboardArrowRightIcon />}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <DatePicker
                                    value={endDate}
                                    onChange={this.handleEndDateChange}
                                    format={dateFormat}
                                    className="dark-datepicker slim-input"
                                    label="To"
                                    keyboardIcon={<EventIcon />}
                                    leftArrowIcon={<KeyboardArrowLeftIcon />}
                                    rightArrowIcon={<KeyboardArrowRightIcon />}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                    </>
                )}
            </Grid>
        );
    }
}

export default AdminDateFilter;
